import { match } from "ts-pattern";

import type { TermsAndConditions } from "@thalamos/aspire-common";

export function getTermsAndConditionsLabel(
  type: TermsAndConditions["type"],
): string {
  return match(type)
    .with("terms-of-use", () => "Terms of Use")
    .with("data-processing-agreement", () => "Data Processing Agreement")
    .otherwise(() => "");
}
